import { Component } from '@angular/core';

@Component({
    selector: 'app-category-menu-items',
    templateUrl: './category-menu-items.component.html',
    styleUrls: ['./category-menu-items.component.scss']
})
/** Category-Menu-Items component*/
export class CategoryMenuItemsComponent {
    /** Category-Menu-Items ctor */
    constructor() {

  }
  dropdownStatus = "";

  MenuItemsToggle() {
    if (this.dropdownStatus == "") {
      this.dropdownStatus = "open";
    } else {
      this.dropdownStatus = "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ui-components/category-menu-items/category-menu-items.component.ts